module.exports = __webpack_public_path__ + "static/img/prd_type2_img.b4deb3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prd_type2_img.jpg
// module id = IxcZ
// module chunks = 34